'use client';

import { UiKitButton } from '@components/UiKitButton';
import { useCallback } from 'react';
import { INNER_API_ROUTES } from 'src/constants';
import { useRootStore } from 'src/providers';

import styles from './index.module.css';

export const ResetButton = () => {
  const store$ = useRootStore();

  const handleReset = useCallback(async () => {
    await fetch(INNER_API_ROUTES.LOGOUT, { method: 'POST' });
    localStorage.clear();
    sessionStorage.clear();

    store$?.user.email.set('');
    typeof window !== 'undefined' && window.location.replace('/');
  }, [store$]);

  return (
    <UiKitButton className={styles.button} size="sm" onClick={handleReset}>
      RESET
    </UiKitButton>
  );
};
